import { type ApiResponse } from '@type/api'
import { axiosProxy } from '@utils/axios'
import { isAxiosError } from 'axios'

// Бэкенд разрешает повторную отправку кода не чаще одного раза в минуту.
const RESEND_COOLDOWN_SECONDS = 60

export interface SendVerificationCodeResult {
  cooldownSeconds: number
}

interface EmailCodeData {
  success: boolean
  retryAfterMs?: number
}

export class VerificationError extends Error {
  constructor(message: string, cause: unknown) {
    super(message, { cause })
    this.name = 'VerificationError'
  }
}

export async function sendVerificationCode(email: string): Promise<SendVerificationCodeResult> {
  try {
    await axiosProxy.post<ApiResponse<EmailCodeData>>('/auth/email-code', { email })
    return { cooldownSeconds: RESEND_COOLDOWN_SECONDS }
  } catch (error) {
    if (isAxiosError<ApiResponse<EmailCodeData>>(error) && error.response?.status === 429) {
      const retryAfterMs = error.response.data?.data?.retryAfterMs ?? RESEND_COOLDOWN_SECONDS * 1000
      return { cooldownSeconds: Math.ceil(retryAfterMs / 1000) }
    }

    const message = isAxiosError<ApiResponse<EmailCodeData>>(error) ? error.response?.data?.errorText : undefined
    throw new VerificationError(message || 'Не удалось отправить письмо. Попробуйте ещё раз.', error)
  }
}
export async function verifyCode(email: string, code: string): Promise<void> {
  try {
    await axiosProxy.post<ApiResponse<EmailCodeData>>('/auth/email-code/verify', { email, code })
  } catch (error) {
    const message = isAxiosError<ApiResponse<EmailCodeData>>(error) ? error.response?.data?.errorText : undefined
    throw new VerificationError(message || 'Неверный код. Проверьте письмо и попробуйте снова.', error)
  }
}
